
import axios, { AxiosResponse } from 'axios';
import {Response, ApiResponse} from '../../interface/IResponse';
import {ResponseCreateMember, MemberTabDetails, ResponseMemberTabDetails, 
        RequestMembersRegistryFirstTabUpdate, RequestMembersRegistryFirstTab, 
        RequestMembersRegistrySecondTab, RequestMembersRegistryThirdTab, ResponseMembersRegistryTableData,
        ResponseDepartmentsList, ResponseDepartment, ResultCivilStatus} from '../../interface/IMembersRegistry';
import { get } from 'http';



async function createMembersFunction(payload: RequestMembersRegistryFirstTab) : Promise<AxiosResponse<ResponseCreateMember>> {
    try {
        const apiUrl = `${process.env.REACT_APP_API_URL}/Members`;

        const response: AxiosResponse<ResponseCreateMember> = await axios.post(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        return response;
    } catch (error: any) {
        if(axios.isAxiosError(error)){
          
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }
}


async function updateMemberTabDetailsFunction(memberId: number, payload: MemberTabDetails){
    try
    {

        var apiUrl = process.env.REACT_APP_API_URL + "/members/updateMemberTabDetails/" + memberId;

        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
        if(axios.isAxiosError(error)){
        
           throw error.response?.data.message;

        }
        else{
            throw error;
        }

    }
}

async function updateMembersFirstTabFunction(memberId: number, payload: RequestMembersRegistryFirstTab){
    try
    {

        var apiUrl = process.env.REACT_APP_API_URL + "/members/updateTab1/" + memberId;
        
        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
        if(axios.isAxiosError(error)){
            
           throw error.response?.data.message;

        }
        else{
            throw error;
        }

    }
}

async function updateMembersSecondTabFunction(memberId: number, payload: RequestMembersRegistrySecondTab) : Promise<AxiosResponse<Response>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/members/updateTab2/" + memberId;
        
        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

       
        return response;
    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }

}

async function updateMembersThirdTabFunction(memberId: number, payload: RequestMembersRegistryThirdTab) : Promise<AxiosResponse<Response>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/members/updateTab3/" + memberId;

        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        

        return response;
    }
    catch(error){
        if(axios.isAxiosError(error)){
            
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }

}

async function createUpdateMembersThirdTabFunction(memberId: number, payload: RequestMembersRegistryThirdTab) : Promise<AxiosResponse<Response>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/members/createMemberUpdateTab3/" + memberId;

        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });


        return response;
    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }

}

async function deleteMemberFunction(memberId: number): Promise<AxiosResponse<Response>> {

    try
    {

        var apiUrl = process.env.REACT_APP_API_URL + "/members/" + memberId;

        var response : AxiosResponse<Response> = await axios.delete(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });


        return response;

    }
    catch(error){

        if(axios.isAxiosError(error)){
            
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }

}

async function listMembersFunction() : Promise<AxiosResponse<ResponseMembersRegistryTableData>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/members/list";

        const response: AxiosResponse<ResponseMembersRegistryTableData> = await axios.get<ResponseMembersRegistryTableData>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
                
               throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function getMemberDetailsTabFunction(memberId: number) : Promise<AxiosResponse<ResponseMemberTabDetails>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Members/getMemberTabDetails/" + memberId;

        const response: AxiosResponse<ResponseMemberTabDetails> = await axios.get<ResponseMemberTabDetails>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function updateTab1NoPasswordFunction(memberId: number, payload: RequestMembersRegistryFirstTabUpdate) : Promise<AxiosResponse<Response>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/members/updateTab1NoPassword/" + memberId;

        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });


        return response;
    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }

}


async function listDepartmentsFunction() : Promise<AxiosResponse<ResponseDepartmentsList>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/departments/list";

        const response: AxiosResponse<ResponseDepartmentsList> = await axios.get<ResponseDepartmentsList>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function getDepartmentByIdFunction(departmentId: number) : Promise<AxiosResponse<ResponseDepartment>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + `/departments/${departmentId}`;

        const response: AxiosResponse<ResponseDepartment> = await axios.get<ResponseDepartment>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){

        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function getCivilStatusListFunction() : Promise<AxiosResponse<ApiResponse<ResultCivilStatus[]>>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + `/Members/getCivilStatusList`;

        const response: AxiosResponse<ApiResponse<ResultCivilStatus[]>> = await axios.get<ApiResponse<ResultCivilStatus[]>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){

        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function getCivilStatusByValueFunction(civilStatusValue: number) : Promise<AxiosResponse<ApiResponse<string>>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + `/Members/getCivilStatusNameByValue/${civilStatusValue}`;

        const response: AxiosResponse<ApiResponse<string>> = await axios.get<ApiResponse<string>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){

        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}




const membersRegistryService = {
    createMembers: createMembersFunction,
    listMembers: listMembersFunction,
    updateMembersFirstTab: updateMembersFirstTabFunction,
    updateMembersSecondTab: updateMembersSecondTabFunction,
    updateMembersThirdTab : updateMembersThirdTabFunction,
    deleteMember: deleteMemberFunction,
    updateTab1NoPassword: updateTab1NoPasswordFunction,
    getMemberDetailsTab: getMemberDetailsTabFunction,
    updateMemberTabDetails: updateMemberTabDetailsFunction,
    createUpdateMembersThirdTab: createUpdateMembersThirdTabFunction,
    listDepartments: listDepartmentsFunction,
    getDepartmentById : getDepartmentByIdFunction,
    getCivilStatusList : getCivilStatusListFunction,
    getCivilStatusByValue : getCivilStatusByValueFunction
}

export default membersRegistryService;